import React, { useEffect, useState, useContext } from "react";
import { Routes, Route, useLocation, useNavigate } from "react-router-dom";
import "./Admin.css";
import { UserContext } from "../../../contexts/CurrentUserContext";
import SubNavigation from "./SubNavigation/SubNavigation";
import RegisterUser from "./Register/Register";
import Users from "./Users/Users";
import UpdateUser from "./UpdateUser/UpdateUser";
import UpdatePassword from "./UpdatePassword/UpdatePassword";
import ChangeAccessLevel from "./ChangeAccessLevel/ChangeAccessLevel";

function Admin() {
  const location = useLocation();
  const navigate = useNavigate();
  const [activeTab, setActiveTab] = useState(1);
  const { userData } = useContext(UserContext);

  // Проверяем роли пользователя
  const isAdmin =
    userData?.access_levels?.some((level) => level.name === "АДМС") || false;
  const isSystemAdmin =
    userData?.access_levels?.some((level) => level.name === "СИСТЕМАДМ") ||
    false;
  const hasLimitedAccess =
    userData?.access_levels?.some(
      (level) => level.name === "ИК" || level.name === "ФИН",
    ) || false;

  const allSubTabs = [
    { id: 1, label: "РЕГИСТРАЦИЯ", path: "register", Component: RegisterUser },
    { id: 2, label: "РЕДАКТИРОВАНИЕ", path: "update", Component: UpdateUser },
    {
      id: 3,
      label: "СМЕНА ПАРОЛЯ",
      path: "update-password",
      Component: UpdatePassword,
    },
    {
      id: 4,
      label: "УРОВНИ ДОСТУПА ПОЛЬЗОВАТЕЛЕЙ",
      path: "change-access-level",
      Component: ChangeAccessLevel,
    },
    { id: 5, label: "ВСЕ ПОЛЬЗОВАТЕЛИ", path: "users", Component: Users },
  ];

  // Для СИСТЕМАДМ: только регистрация и смена пароля
  const systemAdminSubTabs = allSubTabs.filter((tab) =>
    ["РЕГИСТРАЦИЯ", "СМЕНА ПАРОЛЯ"].includes(tab.label),
  );

  // Для ИК и ФИН: только редактирование и просмотр всех пользователей
  const limitedAccessSubTabs = allSubTabs.filter((tab) =>
    ["РЕДАКТИРОВАНИЕ", "ВСЕ ПОЛЬЗОВАТЕЛИ"].includes(tab.label),
  );

  // Определяем доступные вкладки в зависимости от роли
  let subTabs;
  if (isAdmin) {
    // АДМС - полный доступ ко всем вкладкам, включая Роли
    subTabs = allSubTabs;
  } else if (isSystemAdmin) {
    // СИСТЕМАДМ - только регистрация и смена пароля
    subTabs = systemAdminSubTabs;
  } else if (hasLimitedAccess) {
    // ИК и ФИН - только редактирование и просмотр
    subTabs = limitedAccessSubTabs;
  } else {
    // По умолчанию - полный доступ (на случай других ролей)
    subTabs = allSubTabs;
  }

  useEffect(() => {
    const currentPath = location.pathname.split("/").pop();
    const currentTab =
      subTabs.find((tab) => tab.path === currentPath) || subTabs[0];
    setActiveTab(currentTab.id);
  }, [location.pathname, subTabs]);

  const handleTabChange = (tabId) => {
    const tab = subTabs.find((tab) => tab.id === tabId);
    if (tab) {
      navigate(`/account/admin/${tab.path}`);
    }
  };

  return (
    <div className="administration">
      <SubNavigation
        activeSubTab={activeTab}
        setActiveSubTab={handleTabChange}
        subTabs={subTabs}
      />
      <Routes>
        {subTabs.map((tab) => (
          <Route key={tab.id} path={tab.path} element={<tab.Component />} />
        ))}
        <Route
          index
          element={
            isSystemAdmin ? (
              <RegisterUser />
            ) : hasLimitedAccess ? (
              <UpdateUser />
            ) : (
              <RegisterUser />
            )
          }
        />
      </Routes>
    </div>
  );
}

export default Admin;
